<section class="flex flex-wrap items-center gap-x-6 gap-y-1 text-[10px] text-[#b0b0b0]">
  <span class="flex items-center gap-1.5">
    <span class="capitalize-first-letter">{{ 'IOT_DICTIONARY.CREATED_AT' | translate }}</span>
    <span class="font-semibold">{{ createdAt() | dateFormat }}</span>
    @if (createdBy(); as createdBy) {
      <span class="capitalize-first-letter">{{ 'IOT_DICTIONARY.BY' | translate }}</span>
      <span class="font-semibold">{{ createdBy | userName }}</span>
    }
  </span>
  @if (updatedAt()) {
    <span class="flex items-center gap-1.5">
      <span class="capitalize-first-letter">{{ 'IOT_DICTIONARY.UPDATED_AT' | translate }}</span>
      <span class="font-semibold">{{ updatedAt() | dateFormat }}</span>
      @if (updatedBy(); as updatedBy) {
        <span class="capitalize-first-letter">{{ 'IOT_DICTIONARY.BY' | translate }}</span>
        <span class="font-semibold">{{ updatedBy | userName }}</span>
      }
    </span>
  }
</section>
